import BuilderSetting from "./selector";

export default BuilderSetting;
